import React from 'react';
import { Outlet } from 'react-router-dom';
import { LivingHeader } from '../living/LivingHeader';
import { Footer } from './Footer';
import { CartDrawer } from './CartDrawer';
export function LivingLayout() {
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-258" data-mp="1fndgb9jnsg66">
      <LivingHeader data-id="element-259" data-mp="1anhe9fuiuyt9" />
      <main className="flex-1" data-id="element-260" data-mp="1ao0la1imw2si">
        <Outlet data-id="element-261" data-mp="1ap279116u9p0" />
      </main>
      <Footer data-id="element-262" data-mp="28azj4fl2bgrz" />
      <CartDrawer data-id="element-263" data-mp="28apvuzrejnpz" />
    </div>;
}